import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { TenantStatusView } from "./TenantStatusView";
import { TenantStatusViewStore } from "../../store/TenantStatusViewStore";
import { useStore } from "../../../../hooks";

export const TenantStatusViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/tenantStatus/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new TenantStatusViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <TenantStatusView tenantStatusViewStore={store} />
      </PageLayout>
    </div>
  );
});
